import axios from "@/lib/axios";

const getFlatRateLens = () => {
  return axios.get("/facility/orders/flat_rate_lens");
}

export default getFlatRateLens;